// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1ccW-","signatureButtonsRight":"ModalSign_signatureButtonsRight__2ccn7"};